import MedagliereGenerale from "../medagliere/MedagliereGenerale";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function Medagliere() {
  const { t } = useTranslation();

  return (
    <section id="medagliere" className="base-section">
      <div className="order-2 md:order-2">
        <MedagliereGenerale />
      </div>
      <div className="base-text-container order-1 md:order-1">
        <h2 className="base-title">{t("medagliere.title")}</h2>
        <p className="base-paragraph">{t("medagliere.text")}</p>
        <Link to="/medagliere" className="base-link">
          {t("medagliere.more")}
          <i className="fas fa-angle-right ml-1 text-xl text-current"></i>
        </Link>
      </div>
    </section>
  );
}

export default Medagliere;
